module.exports = __webpack_public_path__ + "static/media/apply-cover-Desktop.4820309b.png";